import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSagesureLogoInverse = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 87,
	height: 29,
	viewBox: "0 0 87 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_2",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M38.0481 23.808C38.3882 24.9788 39.2189 25.6209 40.4475 25.6209C41.4864 25.6209 42.4305 25.2426 42.4305 24.2604C42.4305 23.7502 42.147 23.2782 40.901 22.8432L39.4653 22.3515C36.5372 21.3508 36.1022 19.5182 36.1022 18.4226C36.1022 16.0429 37.9729 14.569 40.5597 14.569C42.5994 14.569 44.1866 15.5512 44.9803 17.4589L42.5994 18.6494C42.0325 17.3085 41.107 17.157 40.5597 17.157C39.6527 17.157 38.954 17.5156 38.954 18.3844C38.954 18.7246 39.0488 19.3481 40.3712 19.8017L41.7687 20.2933C44.735 21.2189 45.2637 22.9947 45.2822 24.2037C45.2822 26.9803 42.8643 28.2089 40.5412 28.2089C38.0099 28.2089 35.7054 26.7732 35.4404 24.3171L38.0481 23.808Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M58.1019 14.7784V22.9959C58.1019 26.3961 55.5891 28.2101 52.624 28.2101C49.6588 28.2101 47.1646 26.3973 47.1646 22.9959V14.7784H50.0927V22.9959C50.0927 24.8285 51.2635 25.754 52.624 25.754C53.9845 25.754 55.1738 24.8285 55.1738 22.9959V14.7784H58.1019Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M68.3765 23.0897L71.4215 28.0296H68.4934L65.7515 23.2967H63.9953V28.0563H61.0857V14.7784H66.9605C69.6803 14.7784 71.1728 16.7996 71.1728 19.1226C71.1728 20.9933 70.1142 22.5424 68.3765 23.0897ZM66.5822 20.9552C67.6211 20.9552 68.2446 20.1997 68.2446 19.1041C68.2446 17.99 67.6211 17.2346 66.5822 17.2346H63.9941V20.9563H66.5822V20.9552Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					d: "M73.5813 28.0273V14.7784H82.3645V17.1015H76.5083V20.3501H81.5894V22.6732H76.5083V25.6765H82.3645V28.0262H73.5813V28.0273Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_3",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_5",
					d: "M37.9902 9.23905C38.3304 10.4098 39.161 11.0519 40.3897 11.0519C41.4286 11.0519 42.3726 10.6736 42.3726 9.6914C42.3726 9.18121 42.0892 8.70919 40.8432 8.27419L39.4074 7.78251C36.4793 6.78178 36.0443 4.94924 36.0443 3.85365C36.0443 1.4739 37.915 0 40.5019 0C42.5415 0 44.1288 0.982214 44.9224 2.88995L42.5415 4.08041C41.9746 2.73955 41.0491 2.588 40.5019 2.588C39.5949 2.588 38.8961 2.94664 38.8961 3.81548C38.8961 4.15561 38.991 4.77918 40.3133 5.23269L41.7108 5.72437C44.6772 6.6499 45.2059 8.42575 45.2244 9.63472C45.2244 12.4113 42.8064 13.6399 40.4834 13.6399C37.9521 13.6399 35.6475 12.2042 35.3826 9.74809L37.9902 9.23905Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_6",
					d: "M45.9116 13.4328L51.0124 0.209351H53.8642L59.0402 13.4328H55.9802L55.0361 10.9582V10.9963H49.8416V10.9582L48.9346 13.4328H45.9116ZM50.6341 8.59692H54.2043L52.447 3.30755L50.6341 8.59692Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_7",
					d: "M66.3831 0.00231934C68.3857 0.00231934 69.7832 0.68258 71.1438 1.70297L69.6895 3.87564C68.9723 3.34693 67.7818 2.66667 66.478 2.68518C63.2664 2.68518 62.1708 4.95156 62.1708 6.8593C62.1708 9.23906 63.8518 10.9582 66.2512 10.9582C67.0634 10.9582 67.9889 10.8067 68.6877 10.4665V8.57731H65.3442V6.23457H71.4272V11.6177C69.4628 13.375 67.4787 13.6388 66.2697 13.6388C62.209 13.6388 59.2427 10.5602 59.2427 6.81997C59.2427 3.13753 61.9626 0.00231934 66.3831 0.00231934Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_8",
					d: "M73.5813 13.4328V0.209351H82.3645V2.53242H76.5083V5.78101H81.5894V8.10408H76.5083V11.1074H82.3645V13.4305H73.5813V13.4328Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_4",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_9",
					d: "M30.4635 0.00231934C30.4635 0.00231934 18.5451 0.00231934 13.8376 0.00231934C8.94967 0.00231934 5.9984 3.26364 5.9984 3.26364L0.625732 8.61549C0.625732 8.61549 13.59 8.61549 17.247 8.61549C22.1708 8.61549 25.0908 5.35417 25.0908 5.35417L30.4635 0.00231934Z",
					fill: "#80BC00"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_10",
					d: "M30.4635 19.4441C30.4635 19.4441 18.5451 19.4441 13.8376 19.4441C8.94967 19.4441 5.9984 22.7054 5.9984 22.7054L0.625732 28.0573C0.625732 28.0573 13.59 28.0573 17.247 28.0573C22.1708 28.0573 25.0908 24.7959 25.0908 24.7959L30.4635 19.4441Z",
					fill: "#80BC00"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_11",
					d: "M30.4635 18.3346C30.4635 18.3346 18.5451 18.3346 13.8376 18.3346C8.94967 18.3346 5.9984 15.0733 5.9984 15.0733L0.625732 9.72144C0.625732 9.72144 13.59 9.72144 17.247 9.72144C22.1708 9.72144 25.0908 12.9828 25.0908 12.9828L30.4635 18.3346Z",
					fill: "#80BC00"
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "Group_5",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector_12",
				d: "M84.262 1.24832C84.262 1.04817 84.3082 0.861913 84.4008 0.689534C84.4933 0.518312 84.6218 0.382954 84.786 0.28346C84.9503 0.185123 85.1273 0.135376 85.3182 0.135376C85.5091 0.135376 85.6861 0.185123 85.8504 0.28346C86.0147 0.381797 86.1431 0.517155 86.2356 0.689534C86.3282 0.860756 86.3745 1.04702 86.3745 1.24832C86.3745 1.44615 86.3294 1.6301 86.2391 1.80016C86.1489 1.97139 86.0216 2.1079 85.8573 2.21087C85.6931 2.31383 85.5137 2.36473 85.3182 2.36473C85.1227 2.36473 84.9422 2.31383 84.7779 2.21087C84.6137 2.1079 84.4864 1.97139 84.3962 1.80016C84.3071 1.6301 84.262 1.44615 84.262 1.24832ZM84.3892 1.24832C84.3892 1.42648 84.4309 1.59192 84.513 1.74463C84.5963 1.89734 84.7097 2.01766 84.8543 2.10559C84.9989 2.19351 85.1539 2.23747 85.3194 2.23747C85.4848 2.23747 85.6398 2.19351 85.7856 2.10559C85.9302 2.01766 86.0436 1.89734 86.1257 1.74347C86.2079 1.58961 86.2484 1.42533 86.2484 1.24832C86.2484 1.07363 86.2079 0.910502 86.1281 0.760105C86.0471 0.60855 85.9349 0.489389 85.7914 0.39915C85.6468 0.310069 85.4894 0.264949 85.3205 0.264949C85.1539 0.264949 84.9978 0.308911 84.8543 0.396836C84.7097 0.484761 84.5963 0.603923 84.5142 0.755478C84.4297 0.907032 84.3892 1.07131 84.3892 1.24832ZM85.0776 1.34087V1.85569H84.9318V0.606237H85.3159C85.4617 0.606237 85.5739 0.636316 85.6526 0.697632C85.7312 0.758948 85.7706 0.8515 85.7706 0.975289C85.7706 1.10718 85.7012 1.20436 85.5612 1.26799C85.6329 1.29344 85.6826 1.33393 85.7104 1.3883C85.7382 1.44268 85.7521 1.50747 85.7521 1.58266C85.7521 1.65786 85.7544 1.7134 85.7578 1.74695C85.7613 1.7805 85.7683 1.80942 85.7775 1.8314V1.85569H85.626C85.6121 1.81983 85.6051 1.72959 85.6051 1.58382C85.6051 1.49474 85.5866 1.43227 85.5496 1.39525C85.5126 1.35823 85.449 1.33971 85.3599 1.33971H85.0776V1.34087ZM85.0776 1.20667H85.3471C85.427 1.20667 85.4941 1.18585 85.5461 1.1442C85.5982 1.10255 85.6236 1.04702 85.6236 0.978761C85.6236 0.894306 85.6017 0.834147 85.5589 0.798283C85.5161 0.762419 85.4409 0.742751 85.3356 0.740437H85.0764V1.20667H85.0776Z",
				fill: "white"
			})
		})
	]
});
export default SvgSagesureLogoInverse;
